import * as React from 'react'

import { Box, Divider, Icon, Popover, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import MinutesToText from 'modules/attendance/components/MinutesToText'

interface PlannedHoursBreakdownProps {
  estimatedMinutes: number
  estimatedRegularMinutes: number
  estimatedOvertimeMinutes: number
}

const PlannedHoursBreakdown = ({
  estimatedMinutes,
  estimatedRegularMinutes,
  estimatedOvertimeMinutes,
}: PlannedHoursBreakdownProps) => {
  const [descriptionHover, setDescriptionHover] = React.useState<boolean>(false)

  return (
    <Box
      paddingY="s4"
      onMouseEnter={() => setDescriptionHover(true)}
      onMouseLeave={() => setDescriptionHover(false)}
    >
      <Popover.ItemList
        gapDivider={false}
        attachment="bottom center"
        open={descriptionHover}
        toggle={() => () => undefined}
      >
        <Box
          borderRadius={{
            all: 'abs004',
          }}
          background="grey100"
        >
          <Icon.Small color="grey600" icon="info" />
        </Box>
        <Box gap="s16">
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text color="grey000White" weight="semibold" size="300">
              {i18n.t('clock_in.bank_of_hours.counters.planned_hours.title')}
            </Text>

            <MinutesToText
              color="grey000White"
              value={estimatedMinutes}
              size="300"
              weight="semibold"
            />
          </Box>
          <Divider backgroundColor="#FFFFFF" />

          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text color="grey000White" size="200">
              {i18n.t('clock_in.bank_of_hours.counters.planned_hours.regular')}
            </Text>

            <MinutesToText color="grey000White" value={estimatedRegularMinutes} size="200" />
          </Box>
        </Box>

        <Box flexDirection="row" justifyContent="spaceBetween">
          <Text color="grey000White" size="200">
            {i18n.t('clock_in.bank_of_hours.counters.planned_hours.overtime')}
          </Text>

          <MinutesToText color="grey000White" value={estimatedOvertimeMinutes} size="200" />
        </Box>
      </Popover.ItemList>
    </Box>
  )
}

export default PlannedHoursBreakdown
